import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';


import Utils from 'src/app/utils';

@Component({
  selector: 'app-awards-workerrankings',
  templateUrl: './workerrankings.component.html',
  styleUrls: ['./workerrankings.component.scss']
})
export class WorkerrankingsComponent implements OnInit {

  rankings: any;
  @Input() month = null;
  
  u = Utils;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getWorkerRankings();

  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    //console.log(changes);
    this.getWorkerRankings();
  }

  getWorkerRankings(){

    this.okService.get("awards/workerrankings",{month:this.month})
    .subscribe((data) => {

      this.rankings = data.body;

      //console.log('getWorkRankings', data);

    });

  }

}
